const colors = {
  white: '#ffffff',
  black: '#000000',
  yellow: '#f8df10',
  purple: '#5d0e8b',
  darkPurple: '#32094a',
  // medium purple found to contrast ADA requierements here.
  // https://adasitecompliance.com/ada-color-contrast-checker/
  mediumPurple: '#7c28ad',
  gridPurple: '#a04fd0',
  whiteTransparent: 'rgba(255, 255, 255, 0.7)'
}

export const palette = {
  ...colors,
  menuForeground: colors.yellow,
  menuBackground: colors.mediumPurple
}
